<template>
	<div class="poplurScience">
		<div class="content">
			<div class="container" :class="{'plant_container':this.type === 2 || this.type === 3}">
				<div class="details">
					<div @click="TouriseTo(item.id)" class="tourist" :class="{'special':item.isSpecial}" v-for="(item, index) in TouriseData">
						<div class="details_desc">
							<div>
								<img :src="item.imgSrc" alt="" />
							</div>
							<div class="details_hide">
								<p>{{ item.title }}</p>
								<div>{{ item.desc }}</div>
								<p>查看详情 >>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
							</div>
						</div>
					</div>
					<div @click="TouriseTo(item.id)" class="plant" :class="{'plant_special':item.isSpecial}" v-for="(item, index) in PlantData">
						<div class="details_desc">
							<div>
								<img :src="item.imgSrc" alt="" />
							</div>
							<div class="details_tit">{{ item.title }}</div>
						</div>
					</div>
				</div>
				<div class="pages">
					<el-pagination :page-size="this.pages.limit" :current-page="this.pages.nowPage" :pager-count="5" layout="prev, pager, next" :total="this.pages.maxNum" @current-change="handleCurrentChange"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import HeaderB from '@/components/public/headerB'
	import Code from '@/components/public/code'
	import Footer from '@/components/public/footer'
	export default {
		data() {
			return {
				toHeaderB: {
					title: '总体规划',
		  			parent: '走进湿地',
		  			parentLink: '/stepInWetland/stepInWetland',
		  			child: '',
		  			childLink: '',
		  			longTop: '',
		  			longBottom: 'Resources',
		  			shortValue: '',
		  			isLong: true,
		  			titleShow: false,
		  			searchShow: true,
		  			haveVoice: false,
		  			logoSrc: {
		  				backgroundImage: ''
		  			},
				},
				TouriseData: [],
				PlantData: [],
				type: null,
				pages: {
					nowPage: 1,
					maxPage: null,
					start: 0,
					maxNum: null,
					limit: null,
					search: '',
				}
			}
		},
  		components: {
			HeaderB,
			Code,
			Footer,
	  	},
	  	beforeRouteUpdate(to, from, next) {
	  		// 获取前往的类型
	  		this.type = to.params.type - 0;
	  		this.pages.search = '';
		    next();
		},
		watch: {
			"$route" (to, from) {
      			this.judgeType();
    		}
		},
  		methods: {
  			// 接收子组件搜索内容
  			renderData(data) {
				this.pages.search = data;
				this.pages.nowPage = 1;
				this.pages.start = 0;
				if(this.type === 1) {
					this.getTouriseData();
				} else if(this.type === 2) {
					this.getAnimalData();
				} else if(this.type === 3) {
					this.getPlantData();
				}
  			},
  			// 获取旅游资源数据
  			getTouriseData() {
  				this.axios.get(this.$store.state.Url10 + 'wetlandResource/queryTouriseResourceByPage', 
			    	{	// 通过这种方式解决模糊匹配后台报空指针异常的问题
			        	params: {
			        		'soId': this.$store.state.Soid,
							'startPage': this.pages.nowPage,
							'limit': this.pages.limit,
							'type': 0,
							'Q_title_S_LK': this.pages.search,
			        	}
			    	}
				)
				.then(data => {
					this.pages.maxNum = data.data.total;
					data = data.data.data;
					if(data.length>0){
						this.pages.maxPage = Math.ceil(this.pages.maxNum/this.pages.limit);
					}
					this.showData(data)
				}).catch(err => {
					console.log(err)
				})
  			},
  			// 获取动物资源数据
			getAnimalData() {
				this.toHeaderB.titleShow = false;
				this.axios.get(this.$store.state.Url10 + 'wetland/impression/findAnimalFilter', 
			    	{	// 通过这种方式解决模糊匹配后台报空指针异常的问题
			        	params: {
			        		'soId': this.$store.state.Soid,
							'startPage': this.pages.nowPage,
							'limit': this.pages.limit,
							'type': 0,
							'Q_name_S_LK': this.pages.search,
			        	}
			    	}
				)
				.then(data => {
					this.pages.maxNum = data.data.total;
					data = data.data.data;
					if(data.length>0){
						this.pages.maxPage = Math.ceil(this.pages.maxNum/this.pages.limit);
					}
					this.showData(data)
				}).catch(err => {
					console.log(err)
				})
			},
  			// 获取植物资源数据
			getPlantData() {
				this.toHeaderB.titleShow = false;
				this.axios.get(this.$store.state.Url10 + 'wetland/impression/findPlantFilter', 
			    	{	// 通过这种方式解决模糊匹配后台报空指针异常的问题
			        	params: {
			        		'soId': this.$store.state.Soid,
							'startPage': this.pages.nowPage,
							'limit': this.pages.limit,
							'type': 0,
							'Q_name_S_LK': this.pages.search,
			        	}
			    	}
				)
				.then(data => {
					this.pages.maxNum = data.data.total;
					data = data.data.data;
					if(data.length>0){
						this.pages.maxPage = Math.ceil(this.pages.maxNum/this.pages.limit);
					}
					this.showData(data)
				}).catch(err => {
					console.log(err)
				})
			},
			// 渲染数据
			showData(data) {
				window.scrollTo(0,0);
				this.TouriseData = [];
				this.PlantData = [];
				if(this.type === 1) {
					for(let i in data) {
						if(((i - 0) + 1)%2 === 0) {
							this.TouriseData.push({
								'imgSrc': this.$store.state.Url10 + this.$store.state.imagesFile + data[i].attList[0].uaPath,
								'title': data[i].title,
								'desc': data[i].describe,
								'id': data[i].id,
								'isSpecial': true,
							})
						} else {
							this.TouriseData.push({
								'imgSrc': this.$store.state.Url10 + this.$store.state.imagesFile + data[i].attList[0].uaPath,
								'title': data[i].title,
								'desc': data[i].describe,
								'id': data[i].id,
								'isSpecial': false,
							})
						}
					}
				} else if (this.type === 2) {
					for(let i in data) {
						if((i + 1)%3 === 0) {
							this.PlantData.push({
								'imgSrc': this.$store.state.Url10 + this.$store.state.imagesFile + data[i].attList[0].uaPath,
								'title': data[i].name,
								'id': data[i].id,
								'isSpecial': true,
							})
						} else {
							this.PlantData.push({
								'imgSrc': this.$store.state.Url10 + this.$store.state.imagesFile + data[i].attList[0].uaPath,
								'title': data[i].name,
								'id': data[i].id,
								'isSpecial': false,
							})
						}
					}
				} else if (this.type === 3) {
					for(let i in data) {
						if((i + 1)%3 === 0) {
							this.PlantData.push({
								'imgSrc': this.$store.state.Url10 + this.$store.state.imagesFile + data[i].attList[0].uaPath,
								'title': data[i].name,
								'id': data[i].id,
								'isSpecial': true,
							})
						} else {
							this.PlantData.push({
								'imgSrc': this.$store.state.Url10 + this.$store.state.imagesFile + data[i].attList[0].uaPath,
								'title': data[i].name,
								'id': data[i].id,
								'isSpecial': false,
							})
						}
					}
				}
				this.setHeight();
				this.toHeaderB.titleShow = true;
			},
  			// 自动判断内容高度，不足则补
  			setHeight() {
				setTimeout(function() {
					$('.details').css('height', 'auto');
					let contentHeight = $(window).height() - $('.logo').height() - $('.footer').height() - 90 - 46;
					if($('.details').height() < contentHeight) {
						$('.details').height(contentHeight)
					}
				})
  			},
			// 跳转详情页
  			TouriseTo(id) {
				sessionStorage.type = this.type;
				sessionStorage.id = id;
				sessionStorage.search = this.pages.search;
				this.$router.push({
      				name: 'ResourcePost',
		      		params: {
		          		type: this.type,
		          		id: id,
		          		search: this.pages.search,
		     		}
				})
  			},
  			// 分页切换
			handleCurrentChange(nowpage) {
				this.pages.nowPage = nowpage;
				this.pages.start = this.pages.limit * (nowpage - 1);
				if(this.type === 1) {
					this.getTouriseData();
				} else if(this.type === 2) {
					this.getAnimalData();
				} else if(this.type === 3) {
					this.getPlantData()
				}
			},
			// 判断页面类型
			judgeType() {
      			sessionStorage.type = '';
				sessionStorage.id = '';
				sessionStorage.search = '';
				this.pages.nowPage = 1;
				this.pages.start = 0;
				setTimeout(function() {
					$('.header_nav li').eq(1).find('span').find('a').attr('class', 'header_native');
				}, 0)
				if(this.type === 1) {
					this.toHeaderB.title = '旅游资源';
					this.toHeaderB.child = '旅游资源';
					this.toHeaderB.longTop = 'Tourist';
					this.toHeaderB.childLink = '/stepInWetland/resource/1';
					// this.toHeaderB.logoSrc.backgroundImage = 'url(' + require('../../assets/images/banner/旅游资源banner.png') + ')';
					this.pages.limit = 3;
					this.getTouriseData();
				} else if (this.type === 2) {
					this.toHeaderB.title = '动物资源';
					this.toHeaderB.child = '动物资源';
					this.toHeaderB.longTop = 'Animal';
					this.toHeaderB.childLink = '/stepInWetland/resource/2';
					// this.toHeaderB.logoSrc.backgroundImage = 'url(' + require('../../assets/images/banner/动物资源banner.png') + ')';
					this.pages.limit = 9;
					this.getAnimalData();
				} else if (this.type === 3) {
					this.toHeaderB.title = '植物资源';
					this.toHeaderB.child = '植物资源';
					this.toHeaderB.longTop = 'Plant';
					this.toHeaderB.childLink = '/stepInWetland/resource/3';
					// this.toHeaderB.logoSrc.backgroundImage = 'url(' + require('../../assets/images/banner/植物资源banner.png') + ')';
					this.pages.limit = 9;
					this.getPlantData();
				}
			}
  		},
	  	mounted() {
			this.type = this.$route.params.type - 0;
			this.judgeType();
	  	}
	}
</script>

<style scoped="scoped">
	/*.logo {
	    background-repeat: no-repeat;
	    background-size: auto;
	    background-position: top;
	}*/
	.container {
		position: relative;
    	padding-bottom: 30px;
	}
	.plant_container {
	    overflow: hidden;
	    background: white;
	    padding: 0 20px 30px 20px;
	    box-sizing: border-box;
	}
	.details {
		padding-top: 20px;
	    overflow: hidden;
    	box-sizing: border-box;
	}
	.details>div {
	    float: left;
	    margin-bottom: 50px;
	}
	.tourist {
	    background-color: #EFEFEF;
	    width: 100%;
	}
	.details_desc {
	    width: 100%;
	    position: relative;
	    cursor: pointer;
	    overflow: hidden;
	}
	.plant_container .details_desc {
		overflow: inherit;
	}
	.tourist .details_desc>div:first-child {
	    overflow: hidden;
	    width: 50%;
	}
	.details_hide {
	    position: absolute;
	    left: 0;
	    bottom: 0;
	    display: inline-block;
	    height: 0px;
	    width: 100%;
	    background: rgba(0,0,0,0.4);
	    transition: all 200ms;
	    color: white;
	    text-align: left;
	    padding: 5px 0 0 20px;
	    box-sizing: border-box;
	    overflow: hidden;
	    text-overflow: ellipsis;
	}
	.tourist .details_hide {
	    width: 60%;
	    left: 35%;
	    bottom: 25%;
	    height: 150px;
	    background: white;
	    padding: 10px 20px 0 20px;
	}
	.details .tourist img {
	    width: 100%;
	    height: 300px;
	    transition: .2s linear;
	}
	.details_hide p:nth-child(1) {
	    font-size: 24px;
	}
	.tourist .details_hide p:nth-child(1) {
	    color: black;
	}
	.special .details_desc>div:first-child {
	    float: right;
	}
	.special .details_hide {
	    left: 10%;
	}
	.details_hide>div:nth-child(2) {
	    font-size: 12px;
	    color: rgba(255,255,255,.8);
	    text-indent: 30px;
	}
	.tourist .details_hide>div:nth-child(2) {
	    margin-top: 10px;
	    text-indent: 0;
        height: 35px;
	    color: #7e7e7e;
	    overflow: hidden;
	    text-indent: 25px;
	    text-overflow: ellipsis;
	}
	.tourist .details_hide p:nth-child(3) {
	    display: inline-block;
	    border-top: 1px solid black;
	    padding-top: 5px;
	    margin-top: 20px;
	    color: black;
	}
	.tourist:hover img {
		transform: scale(1.1);
	}
	.tourist:hover .details_hide {
		background: #08961E;
	}
	.tourist:hover .details_hide p:nth-child(1) {
		color: white;
	}
	.tourist:hover .details_hide div:nth-child(2) {
		color: rgba(255, 255, 255, .8);
	}
	.tourist:hover .details_hide p:nth-child(3) {
		border-top-color: white;
		color: white;
	}
	.details .plant {
	    width: 30%;
	    margin-right: 5%;
	}
	.details .plant:hover img {
		transform: scale(1.1);
	}
	.details .plant:hover .details_tit {
		color: #08961E;
	}
	.plant .details_desc {
	    height: 200px;
	}
	.plant .details_desc>div:first-child {
	    height: 200px;
	    overflow: hidden;
	}
	.details_tit {
		padding: 10px 0;
		color: black;
    	transition: .2s linear;
	}
	.details .plant img {
	    width: 100%;
	    height: 200px;
	    transition: .2s linear;
	}
	.details .plant_special {
		margin-right: 0;
	}
</style>

<style>
	/*分页器样式*/
	.poplurScience .el-dialog, .el-pager li, .poplurScience .el-pagination .btn-next, .poplurScience .el-pagination .btn-prev, .poplurScience .el-pagination button:disabled {
		background-color: transparent !important;
	}	
	.poplurScience .el-pagination .btn-next, .poplurScience .el-pagination .btn-prev {
		border: 1px solid #08961E;
		border-radius: 10px;
		height: auto;
		width: 80px;
		transition: .2s linear;
		margin: 0 10px;
	}
	.poplurScience .el-pagination .btn-prev {
		padding-left: 12px;
	}
	.poplurScience .el-pagination .btn-next {
		padding-right: 12px;
	}
	.poplurScience .el-pager li {
		font-size: 20px;
		font-weight: normal;
		padding: 0 10px;
		transition: .2s linear;
		margin-top: 7px;
	}
	.poplurScience .el-pager li.active, .poplurScience .el-pager li:hover, .poplurScience .el-pagination button:hover, .poplurScience .el-pagination .btn-next .el-icon, .poplurScience .el-pagination .btn-prev .el-icon {
		color: #08961E;
	}
	.poplurScience .el-pagination .btn-next .el-icon,.poplurScience  .el-pagination .btn-prev .el-icon {
		font-size: 40px;
	}
	.poplurScience .el-pagination button:hover {
		background: #08961E;
	}
	.poplurScience .el-pagination button:disabled {
		background: transparent;
	}
	.poplurScience .el-pagination button:hover i {
		color: #03c01f !important;
	}
	.poplurScience .el-pagination button:disabled i {
		color: rgb(210, 210 ,210) !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/stepInWetland/resource.vue